import produce from 'immer';

// // UTILS
// import { formatDate } from 'utils/genericFunctions';

// TYPES
import { Types, LogonRest } from './types';
import { ReducerAction } from '../../../../types';

export const INITIAL_STATE: LogonRest = {
	status: 0,
	mensagem: '',
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): LogonRest {
	return produce(state, draft => {
		switch (action.type) {
			case Types.LOGON_REST_REQUEST: {
				draft.status = 100;
				draft.mensagem = INITIAL_STATE.mensagem;
				break;
			}

			case Types.LOGON_REST_SUCCESS: {
				draft.status = 200;
				draft.mensagem = action.payload.mensagem ? action.payload.mensagem : '';
				break;
			}

			case Types.LOGON_REST_FAILURE: {
				draft.status = 400;
				draft.mensagem = action.payload.data.data.mensagem
					? action.payload.data.data.mensagem.trim()
					: '';
				break;
			}
			case Types.LOGON_REST_CLEAR: {
				draft.status = 0;
				draft.mensagem = INITIAL_STATE.mensagem;
				break;
			}

			default:
		}
	});
}
